"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _FormattedPhoneNumber = _interopRequireDefault(require("I18n/components/FormattedPhoneNumber"));

var _FormattedReactMessage = _interopRequireDefault(require("I18n/components/FormattedReactMessage"));

var _unescapedText = _interopRequireDefault(require("I18n/utils/unescapedText"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _UICopyButton = _interopRequireDefault(require("UIComponents/button/UICopyButton"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _UIList = _interopRequireDefault(require("UIComponents/list/UIList"));

var _urls = require("../../../../utils/urls");

var I18N_PATH = 'appMarketplace.detail.overview.sidebar.contact';

var Link = function Link(props) {
  return _react.default.createElement(_UILink.default, (0, _extends2.default)({}, props, {
    external: true,
    iconProps: {
      className: 'hidden'
    }
  }));
};

var Contact = function Contact(_ref) {
  var chatUrl = _ref.chatUrl,
      companyUrl = _ref.companyUrl,
      email = _ref.email,
      facebookUrl = _ref.facebookUrl,
      hasZorseChatScope = _ref.hasZorseChatScope,
      hasZorseWebticketScope = _ref.hasZorseWebticketScope,
      homemade = _ref.homemade,
      isCustomer = _ref.isCustomer,
      onTrackInteraction = _ref.onTrackInteraction,
      openHelpWidget = _ref.openHelpWidget,
      phone = _ref.phone;
  var trackInteraction = (0, _react.useCallback)(function (action) {
    return onTrackInteraction(action, 'contact');
  }, [onTrackInteraction]);
  var renderedEmailSupportLink = (0, _react.useMemo)(function () {
    var emailSupportIconText = _react.default.createElement(_react.Fragment, null, _react.default.createElement(_UIIcon.default, {
      name: "email"
    }), _react.default.createElement(_FormattedMessage.default, {
      message: I18N_PATH + ".emailSupportLinkText"
    }));

    if (homemade) {
      if (isCustomer && hasZorseWebticketScope) {
        return _react.default.createElement(Link, {
          onClick: function onClick() {
            trackInteraction('click copy email address');
            openHelpWidget({
              create: true
            });
          }
        }, emailSupportIconText);
      } else {
        return null;
      }
    }

    return _react.default.createElement(_UICopyButton.default, {
      hint: (0, _unescapedText.default)(I18N_PATH + ".emailCopyButtonHint"),
      onClick: function onClick() {
        return trackInteraction('click copy email address');
      },
      value: email,
      use: "link"
    }, emailSupportIconText);
  }, [email, hasZorseWebticketScope, homemade, isCustomer, openHelpWidget, trackInteraction]);
  var renderedLiveChatLink = (0, _react.useMemo)(function () {
    var liveChatIconText = _react.default.createElement(_react.Fragment, null, _react.default.createElement(_UIIcon.default, {
      name: "messages"
    }), _react.default.createElement(_FormattedMessage.default, {
      message: I18N_PATH + ".liveChatLinkText"
    }));

    if (homemade) {
      if (isCustomer && hasZorseChatScope) {
        return _react.default.createElement(Link, {
          onClick: function onClick() {
            trackInteraction('click live chat link');
            openHelpWidget({
              chat: true
            });
          }
        }, liveChatIconText);
      } else {
        return null;
      }
    }

    return chatUrl && _react.default.createElement(Link, {
      href: (0, _urls.getFormattedUrl)(chatUrl),
      onClick: function onClick() {
        return trackInteraction('click live chat link');
      }
    }, liveChatIconText);
  }, [chatUrl, hasZorseChatScope, homemade, isCustomer, openHelpWidget, trackInteraction]);
  var renderedPhoneNumber = (0, _react.useMemo)(function () {
    if (!phone) return null;

    var _phone$split = phone.split('-'),
        _phone$split2 = (0, _slicedToArray2.default)(_phone$split, 2),
        phoneNumberBase = _phone$split2[0],
        extension = _phone$split2[1];

    var formattedPhoneNumberBase = _react.default.createElement(_FormattedPhoneNumber.default, {
      value: phoneNumberBase
    });

    return extension ? _react.default.createElement(_react.Fragment, null, _react.default.createElement(Link, {
      href: "tel:" + phoneNumberBase
    }, _react.default.createElement(_UIIcon.default, {
      name: "calling"
    })), _react.default.createElement(_FormattedReactMessage.default, {
      message: I18N_PATH + ".phoneWithExtension",
      options: {
        phoneNumberBase: _react.default.createElement(Link, {
          href: "tel:" + phoneNumberBase
        }, formattedPhoneNumberBase),
        extension: extension
      }
    })) : _react.default.createElement(Link, {
      href: "tel:" + phoneNumberBase
    }, _react.default.createElement(_UIIcon.default, {
      name: "calling"
    }), formattedPhoneNumberBase);
  }, [phone]);
  return _react.default.createElement(_UIList.default, null, renderedEmailSupportLink, companyUrl && _react.default.createElement(Link, {
    href: (0, _urls.getFormattedUrl)(companyUrl),
    onClick: function onClick() {
      return trackInteraction('click company website link');
    }
  }, _react.default.createElement(_UIIcon.default, {
    name: "website"
  }), _react.default.createElement(_FormattedMessage.default, {
    message: I18N_PATH + ".companyWebsiteLinkText"
  })), renderedLiveChatLink, facebookUrl && _react.default.createElement(Link, {
    href: (0, _urls.getFormattedUrl)(facebookUrl),
    onClick: function onClick() {
      return trackInteraction('click facebook link');
    }
  }, _react.default.createElement(_UIIcon.default, {
    name: "socialBlockFacebook"
  }), _react.default.createElement(_FormattedMessage.default, {
    message: I18N_PATH + ".facebookLinkText"
  })), renderedPhoneNumber);
};

Contact.propTypes = {
  chatUrl: _propTypes.default.string,
  companyUrl: _propTypes.default.string,
  email: _propTypes.default.string.isRequired,
  facebookUrl: _propTypes.default.string,
  hasZorseChatScope: _propTypes.default.bool.isRequired,
  hasZorseWebticketScope: _propTypes.default.bool.isRequired,
  homemade: _propTypes.default.bool.isRequired,
  isCustomer: _propTypes.default.bool.isRequired,
  onTrackInteraction: _propTypes.default.func.isRequired,
  openHelpWidget: _propTypes.default.func.isRequired,
  phone: _propTypes.default.string
};
var _default = Contact;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/detail/overview/sidebar/Contact.js
// module id = 826
// module chunks = 209 210 211 212